/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiVatrateV1Id } from '../fn/vat-rate/delete-api-vatrate-v-1-id';
import { DeleteApiVatrateV1Id$Params } from '../fn/vat-rate/delete-api-vatrate-v-1-id';
import { getApiVatrateV1$Json } from '../fn/vat-rate/get-api-vatrate-v-1-json';
import { GetApiVatrateV1$Json$Params } from '../fn/vat-rate/get-api-vatrate-v-1-json';
import { getApiVatrateV1$Plain } from '../fn/vat-rate/get-api-vatrate-v-1-plain';
import { GetApiVatrateV1$Plain$Params } from '../fn/vat-rate/get-api-vatrate-v-1-plain';
import { getApiVatrateV1Id$Json } from '../fn/vat-rate/get-api-vatrate-v-1-id-json';
import { GetApiVatrateV1Id$Json$Params } from '../fn/vat-rate/get-api-vatrate-v-1-id-json';
import { getApiVatrateV1Id$Plain } from '../fn/vat-rate/get-api-vatrate-v-1-id-plain';
import { GetApiVatrateV1Id$Plain$Params } from '../fn/vat-rate/get-api-vatrate-v-1-id-plain';
import { GetVatRateResponse } from '../models/get-vat-rate-response';
import { postApiVatrateV1$Json } from '../fn/vat-rate/post-api-vatrate-v-1-json';
import { PostApiVatrateV1$Json$Params } from '../fn/vat-rate/post-api-vatrate-v-1-json';
import { postApiVatrateV1$Plain } from '../fn/vat-rate/post-api-vatrate-v-1-plain';
import { PostApiVatrateV1$Plain$Params } from '../fn/vat-rate/post-api-vatrate-v-1-plain';
import { postApiVatrateV1Create$Json } from '../fn/vat-rate/post-api-vatrate-v-1-create-json';
import { PostApiVatrateV1Create$Json$Params } from '../fn/vat-rate/post-api-vatrate-v-1-create-json';
import { postApiVatrateV1Create$Plain } from '../fn/vat-rate/post-api-vatrate-v-1-create-plain';
import { PostApiVatrateV1Create$Plain$Params } from '../fn/vat-rate/post-api-vatrate-v-1-create-plain';
import { putApiVatrateV1Id$Json } from '../fn/vat-rate/put-api-vatrate-v-1-id-json';
import { PutApiVatrateV1Id$Json$Params } from '../fn/vat-rate/put-api-vatrate-v-1-id-json';
import { putApiVatrateV1Id$Plain } from '../fn/vat-rate/put-api-vatrate-v-1-id-plain';
import { PutApiVatrateV1Id$Plain$Params } from '../fn/vat-rate/put-api-vatrate-v-1-id-plain';
import { VatRateUpdatedModel } from '../models/vat-rate-updated-model';

@Injectable({ providedIn: 'root' })
export class VatRateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiVatrateV1()` */
  static readonly GetApiVatrateV1Path = '/private/v1/vat-rates';

  /**
   * Retrieves all Aliquote rates (parameter).
   *
   * Retrieves all Aliquote rates (parameter)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatrateV1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1$Plain$Response(params?: GetApiVatrateV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatRateUpdatedModel>> {
    return getApiVatrateV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Aliquote rates (parameter).
   *
   * Retrieves all Aliquote rates (parameter)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatrateV1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1$Plain(params?: GetApiVatrateV1$Plain$Params, context?: HttpContext): Observable<VatRateUpdatedModel> {
    return this.getApiVatrateV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatRateUpdatedModel>): VatRateUpdatedModel => r.body)
    );
  }

  /**
   * Retrieves all Aliquote rates (parameter).
   *
   * Retrieves all Aliquote rates (parameter)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatrateV1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1$Json$Response(params?: GetApiVatrateV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatRateUpdatedModel>> {
    return getApiVatrateV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Aliquote rates (parameter).
   *
   * Retrieves all Aliquote rates (parameter)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatrateV1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1$Json(params?: GetApiVatrateV1$Json$Params, context?: HttpContext): Observable<VatRateUpdatedModel> {
    return this.getApiVatrateV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatRateUpdatedModel>): VatRateUpdatedModel => r.body)
    );
  }

  /** Path part for operation `postApiVatrateV1()` */
  static readonly PostApiVatrateV1Path = '/private/v1/vat-rates';

  /**
   * Retrieves all Aliquote rates.
   *
   * Retrieves all Aliquote rates
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatrateV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1$Plain$Response(params?: PostApiVatrateV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVatRateResponse>> {
    return postApiVatrateV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Aliquote rates.
   *
   * Retrieves all Aliquote rates
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatrateV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1$Plain(params?: PostApiVatrateV1$Plain$Params, context?: HttpContext): Observable<GetVatRateResponse> {
    return this.postApiVatrateV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVatRateResponse>): GetVatRateResponse => r.body)
    );
  }

  /**
   * Retrieves all Aliquote rates.
   *
   * Retrieves all Aliquote rates
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatrateV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1$Json$Response(params?: PostApiVatrateV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVatRateResponse>> {
    return postApiVatrateV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Aliquote rates.
   *
   * Retrieves all Aliquote rates
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatrateV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1$Json(params?: PostApiVatrateV1$Json$Params, context?: HttpContext): Observable<GetVatRateResponse> {
    return this.postApiVatrateV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVatRateResponse>): GetVatRateResponse => r.body)
    );
  }

  /** Path part for operation `getApiVatrateV1Id()` */
  static readonly GetApiVatrateV1IdPath = '/private/v1/vat-rates/{id}';

  /**
   * Retrieves a Aliquote by ID.
   *
   * Retrieves a Aliquote by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatrateV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1Id$Plain$Response(params: GetApiVatrateV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VatRateUpdatedModel>>> {
    return getApiVatrateV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Aliquote by ID.
   *
   * Retrieves a Aliquote by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatrateV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1Id$Plain(params: GetApiVatrateV1Id$Plain$Params, context?: HttpContext): Observable<Array<VatRateUpdatedModel>> {
    return this.getApiVatrateV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VatRateUpdatedModel>>): Array<VatRateUpdatedModel> => r.body)
    );
  }

  /**
   * Retrieves a Aliquote by ID.
   *
   * Retrieves a Aliquote by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiVatrateV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1Id$Json$Response(params: GetApiVatrateV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VatRateUpdatedModel>>> {
    return getApiVatrateV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Aliquote by ID.
   *
   * Retrieves a Aliquote by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiVatrateV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiVatrateV1Id$Json(params: GetApiVatrateV1Id$Json$Params, context?: HttpContext): Observable<Array<VatRateUpdatedModel>> {
    return this.getApiVatrateV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VatRateUpdatedModel>>): Array<VatRateUpdatedModel> => r.body)
    );
  }

  /** Path part for operation `putApiVatrateV1Id()` */
  static readonly PutApiVatrateV1IdPath = '/private/v1/vat-rates/{id}';

  /**
   * Updates an existing VAT Rate by ID.
   *
   * Updates an existing VAT Rate by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiVatrateV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatrateV1Id$Plain$Response(params: PutApiVatrateV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VatRateUpdatedModel>>> {
    return putApiVatrateV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing VAT Rate by ID.
   *
   * Updates an existing VAT Rate by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiVatrateV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatrateV1Id$Plain(params: PutApiVatrateV1Id$Plain$Params, context?: HttpContext): Observable<Array<VatRateUpdatedModel>> {
    return this.putApiVatrateV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VatRateUpdatedModel>>): Array<VatRateUpdatedModel> => r.body)
    );
  }

  /**
   * Updates an existing VAT Rate by ID.
   *
   * Updates an existing VAT Rate by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiVatrateV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatrateV1Id$Json$Response(params: PutApiVatrateV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VatRateUpdatedModel>>> {
    return putApiVatrateV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing VAT Rate by ID.
   *
   * Updates an existing VAT Rate by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiVatrateV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiVatrateV1Id$Json(params: PutApiVatrateV1Id$Json$Params, context?: HttpContext): Observable<Array<VatRateUpdatedModel>> {
    return this.putApiVatrateV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VatRateUpdatedModel>>): Array<VatRateUpdatedModel> => r.body)
    );
  }

  /** Path part for operation `deleteApiVatrateV1Id()` */
  static readonly DeleteApiVatrateV1IdPath = '/private/v1/vat-rates/{id}';

  /**
   * Deletes a Aliquote by ID.
   *
   * Deletes a Aliquote by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiVatrateV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiVatrateV1Id$Response(params: DeleteApiVatrateV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiVatrateV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Aliquote by ID.
   *
   * Deletes a Aliquote by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiVatrateV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiVatrateV1Id(params: DeleteApiVatrateV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiVatrateV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiVatrateV1Create()` */
  static readonly PostApiVatrateV1CreatePath = '/private/v1/vat-rates/Create';

  /**
   * Creates a new Aliquote.
   *
   * Creates a new Aliquote.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatrateV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1Create$Plain$Response(params?: PostApiVatrateV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatRateUpdatedModel>> {
    return postApiVatrateV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Aliquote.
   *
   * Creates a new Aliquote.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatrateV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1Create$Plain(params?: PostApiVatrateV1Create$Plain$Params, context?: HttpContext): Observable<VatRateUpdatedModel> {
    return this.postApiVatrateV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatRateUpdatedModel>): VatRateUpdatedModel => r.body)
    );
  }

  /**
   * Creates a new Aliquote.
   *
   * Creates a new Aliquote.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiVatrateV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1Create$Json$Response(params?: PostApiVatrateV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatRateUpdatedModel>> {
    return postApiVatrateV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Aliquote.
   *
   * Creates a new Aliquote.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiVatrateV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiVatrateV1Create$Json(params?: PostApiVatrateV1Create$Json$Params, context?: HttpContext): Observable<VatRateUpdatedModel> {
    return this.postApiVatrateV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<VatRateUpdatedModel>): VatRateUpdatedModel => r.body)
    );
  }

}
